import React from 'react'
import './Setting.css'
// Component
import Holiday from '../../components/setting/Holiday'
import ConfigurationFileUpload from '../../components/setting/ConfigurationFileUpload'
// import Exceptional from '../../components/setting/Exceptional'

const Setting = () => {
  return (
    <div className="w-full mb-8">
      <h1 className="text-center my-4 text-2xl leading-snug uppercase">設定</h1>
      <Holiday />

      {/* <Exceptional /> */}

      <ConfigurationFileUpload />
    </div>
  )
}

export default Setting
